import { getDefaultNodeImage, getNodeImage, getNodeName } from "Areas/SharedFeatures/nodeLabel";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import flatMap from "lodash/flatMap";
import groupBy from "lodash/groupBy";
import head from "lodash/head";
import keys from "lodash/keys";
import map from "lodash/map";
import { SidebarMenuItem } from "../../Common";
import { CHILD_KEY_PREFIX, GROUP_KEY_PREFIX, MASTER_KEY_PREFIX } from "../constants";
export const makeMasterItemKey = (masterNode) => `${MASTER_KEY_PREFIX}_${masterNode.NodeId}`;
export const makeGroupItemKey = (masterNode, documentObject) => `${GROUP_KEY_PREFIX}_${masterNode.NodeId}_${documentObject.Id}`;
export const makeChildItemKey = (masterNode, documentObject, childNode) => `${CHILD_KEY_PREFIX}_${masterNode.NodeId}_${documentObject.Id}_${childNode.NodeId}`;
export default (documentType, documentObjects, content, contentMasterNodes, contentChildren) => {
    if (documentType === DOCUMENT_TYPE.CONTENT) {
        if (contentMasterNodes && keys(contentMasterNodes).length > 0) {
            return map(contentMasterNodes, (masterNode) => {
                const contentGroupItems = map(contentChildren && contentChildren[masterNode.NodeId], (childrenNodes, documentObjectId) => {
                    const documentObject = documentObjects[documentObjectId];
                    const childrenItems = map(childrenNodes, node => {
                        const documentObjectChild = (node === null || node === void 0 ? void 0 : node.DocumentObjectId)
                            ? documentObjects[node.DocumentObjectId]
                            : undefined;
                        return new SidebarMenuItem(makeChildItemKey(masterNode, documentObject, node), node.NodeName ||
                            getNodeName(node.AttributeValues, documentObjectChild) ||
                            (documentObjectChild === null || documentObjectChild === void 0 ? void 0 : documentObjectChild.Name), node.NodeImage || getNodeImage(node.AttributeValues, documentObjectChild, true), undefined, { master: masterNode, object: documentObject, child: node }, undefined);
                    });
                    return new SidebarMenuItem(makeGroupItemKey(masterNode, documentObject), documentObjects[documentObjectId].Name, getDefaultNodeImage(documentObjects[documentObjectId]), undefined, { node: masterNode, object: documentObject }, childrenItems);
                });
                const documentObject = (masterNode === null || masterNode === void 0 ? void 0 : masterNode.DocumentObjectId)
                    ? documentObjects[masterNode.DocumentObjectId]
                    : undefined;
                return new SidebarMenuItem(makeMasterItemKey(masterNode), masterNode.NodeName ||
                    getNodeName(masterNode.AttributeValues, documentObject) ||
                    (documentObject === null || documentObject === void 0 ? void 0 : documentObject.Name), masterNode.NodeImage || getNodeImage(masterNode.AttributeValues, documentObject, true), undefined, masterNode, contentGroupItems);
            });
        }
        return flatMap(groupBy(content, "MasterNodeId"), (masterNodeItems, masterNodeId) => {
            var _a;
            let masterResult = flatMap(groupBy(masterNodeItems, "NodeSource.DocumentObjectId"), (items, documentObjectId) => {
                let result = flatMap(groupBy(items, "NodeId"), (nodeItems, nodeId) => {
                    var _a;
                    let nodeResult = [];
                    if (nodeId) {
                        const node = (_a = head(nodeItems)) === null || _a === void 0 ? void 0 : _a.NodeSource;
                        const documentObject = (node === null || node === void 0 ? void 0 : node.DocumentObjectId)
                            ? documentObjects[node.DocumentObjectId]
                            : undefined;
                        if (node)
                            nodeResult = [
                                new SidebarMenuItem(nodeId, node.NodeName ||
                                    getNodeName(node.AttributeValues, documentObject) ||
                                    (documentObject === null || documentObject === void 0 ? void 0 : documentObject.Name), node.NodeImage || getNodeImage(node.AttributeValues, documentObject, true), undefined, node, undefined)
                            ];
                    }
                    return nodeResult;
                });
                if (documentObjectId && documentObjects[documentObjectId]) {
                    result = [
                        new SidebarMenuItem(documentObjectId, documentObjects[documentObjectId].Name, getDefaultNodeImage(documentObjects[documentObjectId]), undefined, undefined, result)
                    ];
                }
                return result;
            });
            if (masterNodeId) {
                const masterNode = (_a = head(masterNodeItems)) === null || _a === void 0 ? void 0 : _a.MasterNodeSource;
                const documentObject = (masterNode === null || masterNode === void 0 ? void 0 : masterNode.DocumentObjectId)
                    ? documentObjects[masterNode.DocumentObjectId]
                    : undefined;
                if (masterNode)
                    masterResult = [
                        new SidebarMenuItem(masterNodeId, masterNode.NodeName ||
                            getNodeName(masterNode.AttributeValues, documentObject) ||
                            (documentObject === null || documentObject === void 0 ? void 0 : documentObject.Name), masterNode.NodeImage ||
                            getNodeImage(masterNode.AttributeValues, documentObject, true), undefined, masterNode, masterResult)
                    ];
            }
            return masterResult;
        });
    }
    return [];
};
